/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { loading } from 'hocs/loading'

export const withInitialLoad = (initialLoadAction, getParams = props => ({})) => WrappedComponent => compose(
  connect(
    null,
    {
      initialLoadAction,
    },
  ),
  lifecycle<any, any>({
    componentDidMount () {
      this.props.initialLoadAction(getParams(this.props))
        .then(() => {
          this.setState({
            loadProgress: 100,
          })
        })
        .catch(() => {
          this.setState({
            loadProgress: 100,
          })
        })
    },
  }),
  loading,
)(WrappedComponent)
